import React, { useState } from "react";
import { Container, Form, Button, Card, InputGroup, Alert } from "react-bootstrap";
import { BsEyeSlash, BsEye } from "react-icons/bs";
import { Link } from "react-router-dom";
import { CognitoUserPool, CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import awsmobile from "../../aws-exports"; // Update the path to your awsConfig
import "../../styles/LogIn.css"; // Ensure the CSS file is correctly imported

const userPool = new CognitoUserPool({
    UserPoolId: awsmobile.aws_user_pools_id,
    ClientId: awsmobile.aws_user_pools_web_client_id,
});

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        const user = new CognitoUser({
            Username: username,
            Pool: userPool,
        });

        const authDetails = new AuthenticationDetails({
            Username: username,
            Password: password,
        });

        user.authenticateUser(authDetails, {
            onSuccess: (result) => {
                localStorage.setItem("user", result.accessToken.payload.username);

                // Get user attributes to check role
                user.getUserAttributes((err, attributes) => {
                    if (!err && attributes) {
                        const roleAttr = attributes.find(attr => attr.Name === 'custom:role');
                        const userRole = roleAttr ? roleAttr.Value : 'user';
                        localStorage.setItem("userRole", userRole);
                    } else {
                        localStorage.setItem("userRole", "user");
                    }
                    console.log("Login successful!");
                    setIsLoading(false);
                    window.location.href = "/"; // Redirect to home page after login
                });
            },
            onFailure: (err) => {
                setError(err.message || JSON.stringify(err));
                setIsLoading(false);
            },
        });
    };

    return (
        <Container className="d-flex justify-content-center align-items-center login-container" style={{ minHeight: "100vh" }}>
            <Card className="login-card shadow-sm" style={{ maxWidth: "450px", width: "100%" }}>
                <Card.Body className="p-4">
                    <div className="text-center mb-4">
                        <img
                            src="./Suhana_Logo.jpg"
                            alt="Suhana Logo"
                            className="mb-3"
                            style={{ height: "70px", maxWidth: "200px" }}
                        />
                        <div className="text-center hindi-text">मज़ा आ गया!</div>
                    </div>

                    <Form onSubmit={handleLogin}>
                        <Form.Group className="mb-3">
                            <Form.Label>Username</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="email@example.com"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type={showPassword ? "text" : "password"}
                                    placeholder="••••••••"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => setShowPassword(!showPassword)}
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                >
                                    {showPassword ? <BsEyeSlash /> : <BsEye />}
                                </Button>
                            </InputGroup>
                        </Form.Group>

                        <div className="text-end mb-4">
                            <Link to="/forgot-password" className="text-decoration-none" style={{ fontSize: '0.9rem' }}>
                                Forgot Username or Password?
                            </Link>
                        </div>

                        {error && (
                            <Alert variant="danger" className="mb-3">
                                {error}
                            </Alert>
                        )}

                        <Button
                            variant="primary"
                            type="submit"
                            className="w-100 login-btn"
                            disabled={isLoading}
                        >
                            {isLoading ? "Logging in..." : "Login"}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Login;